export const STORAGE_KEYS = {
  AUTH_TOKEN: "auth_token",
  USER_INFO: "user_info",
  THEME_PREFERENCE: "theme_preference",
  LANGUAGE_PREFERENCE: "language_preference",
};


export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 1;

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  CHATINTERFACE: "/chat",
  CHAT_WITH_ID: "/chat/:chatId",
  OVERVIEW: "/overview",
  PROFILE: "/profile",
  CLIENTS: "/clients",
  ARCHIVE: "/archive",
  LEGAL_RESEARCH: "/legal-research",
  CASE_FINDER: "/case-finder",
  DOCUMENT_ANALYZER: "/document-analyzer",
  EVENT_EXTRACTION: "/event-extraction",
  SCANNED_COPY: "/scanned-copy",
  TRANSLATOR: "/translator",
  TRANSLATOR_VIEW: "/translator/view/:documentId",
  SUBSCRIBE_CASES: "/cases",
  SCANNED_COPY_VIEW: "/scanned-copy/view/:documentId",
  DOCUMENT_REVIEW: "/document-review",
  DOCUMENT_DRAFTING: "/document-drafting",
  OCR_PROCESSING: "/ocr-processing",
  CHATAI: "/chat-ai",
  JUDGEMENT_FINDER: "/judgement-finder",
  CALENDAR: "/calendar",
  CUSTOM_DRAFT: "/custom-draft",
  LEGAL_VAULT: "/legal-vault",
  NEUROLOGICAL_RESEARCH: "/neurolawgical-research",
  PROMPT_GUIDE: "/prompt-guide",
  OTP_VERIFICATION: "/otp-verification",
  USER_PROFILE_COMPLETION: "/user-profile-completion",
  USER_WALLET: "/wallet",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
  DISCLAIMER: "/disclaimer",
  DRAFT_PRO: "/draftpro",
  CHOOSE_DRAFTING_METHOD: "/choose-drafting-method",
  NOTIFICATIONS: "/notifications",
  CHANGELOG: "/changelog",
  LINKEDIN_POST_GENERATOR: "/linkedin-post-generator",
  FEEDBACK: "/feedback",
  SETTINGS: "/settings",
  AUDIO_TRANSCRIPTION: "/audio-transcription",
  PDF_TOOLS: "/pdf-tools",
  PAGINATE: "/paginate",
  ERASE: "/erase",
  REMOVE_PAGES: "/remove-pages",
  MERGE_PDF: "/merge-pdf",
  WAITING: "/waiting",
  BANNED: "/banned",
  PRICING: "/pricing",
  ORG_DASHBOARD: "/org/dashboard",
  ORG_INVITATION: "/org-invitation/:token",
  LEGAL_NOTICE: "/legal-notice",
  NOT_FOUND: "*",
};

export const ERROR_MESSAGES = {
  GENERIC_ERROR: "Something went wrong. Please try again later.",
  NETWORK_ERROR: "Network error. Please check your internet connection.",
  UNAUTHORIZED: "You are not authorized to access this resource.",
  NOT_FOUND: "The requested resource was not found.",
  VALIDATION_ERROR: "Please check your input and try again.",
};

export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: "You have successfully logged in.",
  LOGOUT_SUCCESS: "You have successfully logged out.",
  PROFILE_UPDATE_SUCCESS: "Your profile has been updated successfully.",
  PASSWORD_RESET_SUCCESS: "Your password has been reset successfully.",
};

export const TOAST_TIMEOUT = 3000;
export const SESSION_TIMEOUT = 30 * 60 * 1000;
